import { render } from "./Step4.vue?vue&type=template&id=660ef597&scoped=true"
import script from "./Step4.vue?vue&type=script&lang=js"
export * from "./Step4.vue?vue&type=script&lang=js"

import "./Step4.vue?vue&type=style&index=0&id=660ef597&lang=less&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660ef597"]])

export default __exports__